export default function getTransferHistory(state = { transHistory: [] }, action) {
    switch (action.type) {
        case 'TRANS_HISTORY':
            return {
                transHistory: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/gettransferhistory.jsx